import { useAvailablePaymentMethods } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<{
	applePay: boolean;
	googlePay: boolean;
}>;

export function usePaymentMethodIconsWrapper(): Result {
	const { paymentMethods } = useAvailablePaymentMethods();
	return {
		data: {
			applePay: paymentMethods.includes('applePay'),
			googlePay: paymentMethods.includes('googlePay'),
		},
	};
}
